import { FormControl, FormHelperText, Tooltip } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { HelpRounded } from '@material-ui/icons';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import React from 'react';
import { DataApi } from '../../../providers/api-provider';
import { handleStateChangeFromProps, Loader, renderStringAsHtml } from './helpers';
const filter = createFilterOptions();

class AutocompleteInput extends React.Component {
  state = {
    single: null,
    multi: null,
    error: false,
    value: '',
    labeledValue: [],
    enabled: '',
    onChange: null,
    type: 'text',
    name: '',
    title: '',
    width: 12,
    data: '',
    renderedData: [],
    nameKey: 'name',
    formLoaded: false,
    description: '',
    disabled: false,
    hidden: false,
    params: {},
    loading: false,
  };
  /*
  -----------------------------------------------------------------------
  API Functions
  -----------------------------------------------------------------------
  */
  //Load and Render Select Data & Value
  componentDidMount() {
    let reneredItems = [];
    let data = this.state.data;
    const nameKey = this.state.nameKey;
    if (typeof (data) === 'string') {
      this.setState({ loading: true });
      DataApi.getSelect(data).then((res) => {
        const value = this.state.value;
        let labeledValue = [];
        for (let item in res.data) {
          //Label can be extracted from function or direct prop
          let label = typeof (nameKey) === 'function' ? nameKey(res.data[item]) : res.data[item][nameKey];
          reneredItems.push({ value: res.data[item].id, label: label });
          if (value === res.data[item].id || (Array.isArray(value) && (value.indexOf(res.data[item].id) !== -1 || value.findIndex((i) => i.id === res.data[item].id) !== -1)))
            labeledValue.push({ value: res.data[item].id, label: label });
        }
        this.setState({ renderedData: reneredItems, labeledValue: labeledValue, loading: false })
      });

    } else {
      let labeledValue = [];
      const value = this.state.value;
      for (let item in data) {
        reneredItems.push({ value: data[item].id, label: data[item][nameKey] });
        if (value === data[item].id || (Array.isArray(value) && value.indexOf(data[item].id) !== -1))
          labeledValue.push({ value: data[item].id, label: data[item][nameKey] });
      }
      this.setState({ renderedData: reneredItems, labeledValue: labeledValue })
    }

  }
  /*
  -----------------------------------------------------------------------
  RENDER Functions
  -----------------------------------------------------------------------
  */
  static getDerivedStateFromProps(nextProps, prevState) {
    if (!prevState.formLoaded && nextProps.formLoaded) {
      let labeledValue = [];
      const value = nextProps.value;
      let data = nextProps.data;
      if (!data && value)
        data = prevState.data = value
      let nameKey = nextProps.nameKey;
      let idKey = 'id';
      let dataArray = data;

      if (!Array.isArray(dataArray)) {
        dataArray = prevState.renderedData;
        nameKey = 'label';
        idKey = 'value';
      }
      if (Array.isArray(dataArray)) {
        for (let item in dataArray) {
          if (value === dataArray[item][idKey] || (Array.isArray(value) && (value.indexOf(dataArray[item][idKey]) !== -1 || value.findIndex((i) => i.id === dataArray[item][idKey]) !== -1))) {
            labeledValue.push({ value: dataArray[item][idKey] || dataArray[item], label: dataArray[item][nameKey] || dataArray[item] });
          }
        }
      }
      prevState.labeledValue = labeledValue;
    }
    if (!nextProps.value && prevState.labeledValue)
      prevState.labeledValue = [];
    return handleStateChangeFromProps(nextProps, prevState);
  }
  handleChange = (e, item) => {
    if (!item)
      item = { value: null };
    this.state.onChange({
      target: {
        type: 'autocomplete',
        value: Array.isArray(item) ? item.map(a => a.value) : item.value,
        name: this.state.name,
      }
    });

    if (item) {
      if (Array.isArray(item)) {
        item.forEach((element, key) => {
          if (element.new)
            item[key].label = item[key].value
        });
      }
      else
        if (item.new)
          item.label = item.value
      this.setState({
        labeledValue: item,
      });
    }
  };

  render() {

    const { error, enabled, multi, labeledValue, title, width, renderedData,
      description, hidden, name, params, loading, value } = this.state;
    if (hidden) {
      if (typeof (hidden) !== 'function' || hidden())
        return <div />
    }

    const extraRootStyles = {};
    if (description)
      extraRootStyles.paddingRight = 20;
    return (
      <Grid xs={12} item sm={width ? width : 12} data-form-element={name}>
        <FormControl margin={this.props.margin || "normal"} fullWidth error={error && enabled}>
          {description && <Tooltip title={renderStringAsHtml(description)} style={{ alignSelf: 'flex-end', marginBottom: '-20px' }} placement="top"><HelpRounded fontSize='small' /></Tooltip>}
          <div style={extraRootStyles}>
            <Autocomplete
              className={error && enabled ? 'error-border' : ''}
              options={renderedData}
              value={labeledValue}
              //inputValue={value}
              onChange={this.handleChange}
              placeholder={error && enabled ? <span className='error'>{title} {this.props.required ? '*' : ''}</span> : (title + ' ' + (this.props.required ? '*' : ''))}
              multiple={multi}
              creatable={params.creatable}
              renderInput={(params) => <TextField {...params} label={title} />}
              getOptionLabel={(option) => Array.isArray(option) && option.length ? option[0].label : (option.label || "")}
              getOptionSelected={(option, value) => option.value === value}
              selectOnFocus={params.creatable}
              clearOnBlur={params.creatable}
              handleHomeEndKeys={params.creatable}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={title}
                  //variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? <Loader size='20' /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
              noOptionsText={loading ? 'Loading options...' : 'No Options'}
              filterOptions={(options, filterParams) => {
                const filtered = filter(options, filterParams);
                if (!params.creatable || loading)
                  return filtered;
                // Suggest the creation of a new value
                if (filterParams.inputValue !== '') {
                  filtered.push({
                    value: filterParams.inputValue,
                    label: `Add "${filterParams.inputValue}"`,
                    new: true
                  });
                }
                return filtered;
              }}
            />
          </div>
          {error && enabled ? <FormHelperText>{error === true ? 'this field is required' : error}</FormHelperText> : ''}
        </FormControl>
      </Grid>
    );
  }
}

export default AutocompleteInput;